/* HOAD: Popup de avaliações (22/09) — busca reviews recentes da loja
   (proxy /api/geral/judgeme-reviews sem filtro de produto) e cicla um
   card por vez, aparecendo/sumindo sozinho. Fechar (X) esconde só NAQUELA
   página (sessionStorage por pathname, 23/09 — pedido do André: "fechei
   uma vez [numa página] e não aparece mais" [em outra]. Antes era 1 flag
   só pra sessão inteira; indo pra outro produto o popup volta a aparecer).

   23/09: fetch precisa de URL absoluta pro backend (app.hoad.com.br) —
   ver mesmo comentário em hoad-reviews.js. */
(function () {
  var HOAD_API_BASE = 'https://app.hoad.com.br';
  var DISMISS_KEY = 'hoad_review_popup_dismissed_' + window.location.pathname;

  function svgStar(filled) {
    return (
      '<svg class="' + (filled ? 'is-filled' : '') + '" viewBox="0 0 20 20" aria-hidden="true">' +
      '<path d="M10 1l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2L10 14.9 4.4 18l1.4-6.2L1 7.5l6.4-.6z"/></svg>'
    );
  }

  function starsHtml(rating) {
    var n = Math.round(Number(rating) || 0);
    var out = '';
    for (var i = 1; i <= 5; i++) out += svgStar(i <= n);
    return out;
  }

  function reviewerName(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return 'Cliente HOAD';
    return parts.slice(0, 2).join(' ');
  }

  function reviewPhoto(review) {
    var pics = review.pictures || review.photos || [];
    if (!pics.length) return '';
    var p = pics[0];
    // 23/09: mesma correção de hoad-reviews.js -- "small" é 160px, borra
    // esticado no popup. "original"/"huge" (1024px) fica nítido.
    return typeof p === 'string' ? p : (p.urls && (p.urls.original || p.urls.huge || p.urls.small)) || p.url || '';
  }

  function productInfo(review) {
    var handle = review.product_handle || (review.product && review.product.handle);
    var title = review.product_title || (review.product && review.product.title);
    var image = review.product_image || (review.product && review.product.image);
    return { handle: handle, title: title, image: image };
  }

  function render(section, review) {
    var media = section.querySelector('[data-hoad-review-popup-media]');
    var reviewer = section.querySelector('[data-hoad-review-popup-reviewer]');
    var stars = section.querySelector('[data-hoad-review-popup-stars]');
    var quote = section.querySelector('[data-hoad-review-popup-quote]');
    var productLink = section.querySelector('[data-hoad-review-popup-product]');
    var productThumb = section.querySelector('[data-hoad-review-popup-product-thumb]');
    var productName = section.querySelector('[data-hoad-review-popup-product-name]');

    var photo = reviewPhoto(review);
    media.innerHTML = photo ? '<img src="' + photo + '" alt="" loading="lazy">' : '';
    reviewer.textContent = reviewerName((review.reviewer && review.reviewer.name) || review.name);
    stars.innerHTML = starsHtml(review.rating);
    quote.textContent = review.body || review.content || review.title || '';

    var product = productInfo(review);
    if (product.handle) {
      productLink.hidden = false;
      productLink.href = '/products/' + product.handle;
      productThumb.style.backgroundImage = product.image ? 'url(' + product.image + ')' : '';
      productName.textContent = product.title || '';
    } else {
      productLink.hidden = true;
    }
  }

  function init(section) {
    if (sessionStorage.getItem(DISMISS_KEY)) return;

    var closeBtn = section.querySelector('[data-hoad-review-popup-close]');
    closeBtn.addEventListener('click', function () {
      section.classList.remove('is-visible');
      try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignora storage indisponível */ }
    });

    // 23/09 (pedido do André): quando a section está numa página de
    // produto, mostra review DAQUELE produto, não da loja toda — mais
    // natural pra quem adicionou o popup ali esperando ver prova social
    // do produto que está olhando.
    var productId = section.dataset.productId;
    var url = HOAD_API_BASE + '/api/geral/judgeme-reviews' + (productId ? '?product_id=' + encodeURIComponent(productId) : '');

    // Na página de produto: avaliações da família (todas as cores do produto).
    var familia = section.dataset.productIds;
    var busca = (familia && window.HoadReviewsFamilia)
      ? window.HoadReviewsFamilia.buscar(familia, 30).then(function (r) { return { reviews: r }; })
      : fetch(url).then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        return res.json();
      });
    busca
      .then(function (data) {
        var reviews = (data.reviews || data.data || (Array.isArray(data) ? data : []))
          .filter(function (r) { return (r.body || r.content) && Number(r.rating) >= 4; });
        if (!reviews.length) return;

        var interval = (Number(section.dataset.interval) || 7) * 1000;
        var index = 0;
        section.hidden = false;

        function show() {
          render(section, reviews[index]);
          section.classList.add('is-visible');
        }

        // Pequeno atraso antes do primeiro aparecer, pra não competir com o
        // carregamento inicial da página.
        setTimeout(show, 1500);

        setInterval(function () {
          if (sessionStorage.getItem(DISMISS_KEY)) return;
          section.classList.remove('is-visible');
          setTimeout(function () {
            index = (index + 1) % reviews.length;
            show();
          }, 400);
        }, interval);
      })
      .catch(function () { /* silencioso — popup é cosmético, não pode gerar erro visível */ });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-review-popup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-hoad-review-popup]');
    if (section) init(section);
  });
})();
